import { render, staticRenderFns } from "./ClubPlayerClients.vue?vue&type=template&id=8903c27a"
import script from "./ClubPlayerClients.vue?vue&type=script&lang=js"
export * from "./ClubPlayerClients.vue?vue&type=script&lang=js"
import style0 from "./ClubPlayerClients.vue?vue&type=style&index=0&id=8903c27a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports